import { createSlice } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'

export const searchSitesAction = 'internal.sites.requests.search'

export const sitesReducer = combineReducers({
  requests: combineReducers({
    search: h2Api.restReducer(searchSitesAction, { result: [] })
  })
})

export const searchSites = () => {
  return h2Api.get('/sites/list')({ type: searchSitesAction })
}

export default sitesReducer
